import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { X, ChevronDown, ChevronUp } from 'lucide-react';

/**
 * Mobile navigation slide-out menu.
 */
const MobileNav = ({ navigation, isOpen, onClose, companyPhone }) => {
  const [expandedItem, setExpandedItem] = useState(null);

  const toggleExpanded = (itemName) => {
    setExpandedItem(expandedItem === itemName ? null : itemName);
  };

  if (!isOpen) return null;

  return (
    <div className="lg:hidden fixed inset-0 z-50" data-testid="mobile-menu">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-black/50" 
        onClick={onClose}
      />
      
      {/* Menu Panel */}
      <div className="absolute right-0 top-0 h-full w-80 max-w-full bg-white shadow-xl overflow-y-auto">
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-slate-200">
          <span className="font-semibold text-brand-navy">Menu</span>
          <button
            onClick={onClose}
            className="p-2 text-brand-slate hover:text-brand-navy rounded-lg hover:bg-slate-100"
            aria-label="Close menu"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
        
        {/* Navigation Links */}
        <nav className="p-4 space-y-1">
          {navigation.map((item) => (
            <div key={item.name}>
              {item.dropdown ? (
                <>
                  <button
                    onClick={() => toggleExpanded(item.name)}
                    className={`w-full flex items-center justify-between px-4 py-3 rounded-lg text-left font-medium transition-colors ${
                      item.highlight
                        ? 'text-brand-yellow bg-brand-navy/5'
                        : 'text-brand-navy hover:bg-brand-grey'
                    }`}
                  >
                    {item.name}
                    {expandedItem === item.name ? (
                      <ChevronUp className="w-4 h-4" />
                    ) : (
                      <ChevronDown className="w-4 h-4" />
                    )}
                  </button>
                  
                  {expandedItem === item.name && (
                    <div className="ml-4 mt-1 space-y-1">
                      {item.dropdown.map((subItem) => (
                        <Link
                          key={subItem.name}
                          to={subItem.href}
                          onClick={onClose}
                          className="block px-4 py-2 text-sm text-brand-slate hover:text-brand-navy hover:bg-brand-grey rounded-lg transition-colors"
                        >
                          {subItem.name}
                        </Link>
                      ))}
                    </div>
                  )}
                </>
              ) : (
                <Link
                  to={item.href}
                  onClick={onClose}
                  className={`block px-4 py-3 rounded-lg font-medium transition-colors ${
                    item.highlight
                      ? 'text-brand-yellow bg-brand-navy/5'
                      : 'text-brand-navy hover:bg-brand-grey'
                  }`}
                >
                  {item.name}
                </Link>
              )}
            </div>
          ))}
        </nav>
        
        {/* Phone CTA */}
        <div className="p-4 border-t border-slate-200">
          <a
            href={`tel:${companyPhone}`}
            className="block w-full py-3 px-4 bg-brand-navy text-white text-center rounded-lg font-semibold hover:bg-brand-navy/90 transition-colors"
          >
            Call {companyPhone}
          </a>
        </div>
      </div>
    </div>
  );
};

export default MobileNav;
